import React from 'react';
const bonuses = [{
  icon: '🧮',
  title: 'Calculadora Pizzera Pro',
  old: '$97'
}, {
  icon: '🧀',
  title: 'Bordes Rellenos',
  old: '$47'
}, {
  icon: '🌾',
  title: 'Masa Madre Sourdough',
  old: '$37'
}, {
  icon: '🍅',
  title: 'Salsas Secretas de Italia',
  old: '$27'
}, {
  icon: '🫓',
  title: 'Focaccias y Panes',
  old: '$17'
}];
export function BonusSection() {
  return <div className="bg-[#0D0D0D] py-6 px-5" data-id="element-11">
      <div className="max-w-5xl mx-auto" data-id="element-12">
        <h2 className="font-serif text-xl sm:text-2xl md:text-3xl text-[#C0392B] text-center mb-1 uppercase tracking-wider" data-id="element-13">
          5 Bonos Exclusivos <span className="text-[#27AE60]" data-id="element-14">GRATIS</span>
        </h2>
        <div className="w-16 h-0.5 bg-gradient-to-r from-[#C0392B] to-[#F1C40F] mx-auto rounded my-2" data-id="element-15" />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mt-4" data-id="element-16">
          {bonuses.map((bonus, index) => <div key={index} className="bg-[#1A1A1A] border border-[#27AE60]/30 rounded-lg p-3 text-center hover:border-[#27AE60] hover:bg-[#1A2A1A] transition-all" data-id="element-17">
              <span className="text-2xl block mb-1" data-id="element-18">{bonus.icon}</span>
              <h3 className="text-[#27AE60] text-[10px] font-bold uppercase tracking-wide mb-1 font-serif" data-id="element-19">
                {bonus.title}
              </h3>
              <div className="text-[#666] text-[10px] line-through" data-id="element-20">
                {bonus.old}
              </div>
              <div className="text-[#27AE60] text-xs font-bold" data-id="element-21">GRATIS</div>
            </div>)}
        </div>
      </div>
    </div>;
}